module.exports = __webpack_public_path__ + "static/media/match.f20e03e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/match.png
// module id = 195
// module chunks = 0